import Vue from 'vue';
import { MutationTree } from 'vuex';
import { GroupInfo } from '@descomplica/dex-models';

import { GroupState } from './state';

const mutations: MutationTree<GroupState> = {
  SET_GROUPS(state, groups: GroupInfo[]) {
    if (!groups) return;

    groups.forEach(group =>
      Vue.set(state.groups, group.id.toString(), {
        ...state.groups[group.id.toString()],
        ...group,
      }),
    );
  },
  UPDATE_GROUP_ENTITY(state, group: GroupInfo) {
    if (!group) return;

    Vue.set(state.groups, group.id.toString(), {
      ...state.groups[group.id.toString()],
      ...group,
    });
  },
  CLEAN_GROUP_STATE(state, groupId: number) {
    Vue.delete(state.groups, groupId.toString());
  },
};

export default mutations;
